import React from 'react';

const RightChevronIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    style={{ transform: 'rotate(-90deg)' }}
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <g fill="#c5d4db">
        <path d="M12 3.729L10.825 2.5 6 7.551 1.175 2.5 0 3.729 6 10z" />
      </g>
    </g>
  </svg>
);

export default RightChevronIcon;
